import EmblaCarousel from "embla-carousel";

export function eventsCarousel(config = {}) {
  const defaultOptions = {
    align: "start",
    duration: 20,
    slidesToScroll: 1,
    skipSnaps: true,
  };

  const breakpointOptions = {
    640: {
      slidesToScroll: 3,
    },
  };

  return {
    currentBreakpoint: null,
    canScrollNext: true,
    canScrollPrev: false,
    api: null,
    loading: !!config.actionUrl,
    hasEvents: true,

    async init() {
      if (config.actionUrl) {
        await this.loadEvents();
      }

      if (this.hasEvents) {
        this.initCarousel();
      }
    },

    async loadEvents() {
      const listing = this.$refs.listing;

      try {
        const params = new URLSearchParams({ slug: config.slug });
        params.set("displayAvailable", config.displayAvailable);
        params.set("marginStart", config.marginStart);
        const separator = config.actionUrl.includes("?") ? "&" : "?";
        const response = await fetch(
          config.actionUrl + separator + params.toString(),
        );
        if (!response.ok) throw new Error(response.statusText);
        const data = await response.json();

        if (data.count === 0) {
          this.hasEvents = false;
          this.loading = false;
          return;
        }

        // Fade out placeholders, swap in real content, fade back in
        listing.classList.add("transition-opacity", "duration-300");
        listing.classList.add("opacity-0");

        await new Promise((resolve) => setTimeout(resolve, 300));

        this.loading = false;

        // Insert rendered listing HTML before the "See all" card
        const seeAllCard = listing.querySelector(":scope > li");
        if (seeAllCard) {
          seeAllCard.insertAdjacentHTML("beforebegin", data.html);
        }

        // Allow DOM to update before fading in
        requestAnimationFrame(() => {
          listing.classList.remove("opacity-0");
        });
      } catch {
        this.hasEvents = false;
        this.loading = false;
      }
    },

    initCarousel() {
      const viewportNode = this.$refs.viewport;
      const prevButtonNode = this.$refs.prev;
      const nextButtonNode = this.$refs.next;

      this.api = EmblaCarousel(viewportNode, {
        ...defaultOptions,
        ...this.getOptions(window.screen.width),
      });

      prevButtonNode.addEventListener(
        "click",
        () => this.api.scrollPrev(),
        false,
      );
      nextButtonNode.addEventListener(
        "click",
        () => this.api.scrollNext(),
        false,
      );

      this.api.on("scroll", (api) => {
        this.canScrollNext = api.canScrollNext();
        this.canScrollPrev = api.canScrollPrev();
      });
    },

    getOptions(screenWidth) {
      let options = {};
      Object.keys(breakpointOptions).forEach((key) => {
        if (screenWidth >= key) {
          options = breakpointOptions[key];
          this.currentBreakpoint = key;
        }
      });
      return {
        ...defaultOptions,
        ...options,
      };
    },

    reInit() {
      if (!this.api) return;
      const options = this.getOptions(window.screen.width);
      this.api.reInit(options);
    },
  };
}
